import { AnswerDto } from '../answerTypes';
import { myAxios } from '../../util/myAxios';
import { AnsweredCatalogueDto } from '../answeredCatalogueTypes';

export function addOrUpdateAnswer(answer: AnswerDto, answeredCatalogueId: number) : Promise<AnsweredCatalogueDto> {
  return myAxios()
    .then(axios => axios.post('/api/v1/answeredCatalogue/' + answeredCatalogueId + '/question/' + answer.question.id, answer))
    .then(response => response.data)
}
